import template from './adpHeaderLogoTitle.html';
import controller from './adpHeaderLogoTitle.controller';
import './adpHeaderLogoTitle.less';

let adpHeaderLogoTitleComponent = {
  restrict: 'E',
  bindings: {
  },
  transclude: {
    left: "?headerLeft",
    right: '?headerRight'
  },
  template,
  controller
};

export default adpHeaderLogoTitleComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderLogoTitle/adpHeaderLogoTitle.component.js